import { Button } from '@warp-ds/react/components/button';
import { TextField } from '@warp-ds/react/components/textfield';
import { type FormEvent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import { actions as filterActions } from '@/state/filterActions';
import { fetchResults } from '@/state/resultActions';

export const KeywordFilter = () => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const keywords = useSelector((s: PaleState) => s.filters.keywords);
    const [value, setValue] = useState(keywords);

    useEffect(() => setValue(keywords), [keywords]);

    const onSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        dispatch(filterActions.filterByKeywords(value));
        dispatch(fetchResults());
    };

    return (
        <form onSubmit={onSubmit} className="flex gap-x-8 items-start" id="keywordSearchFilter" data-testid="keywordSearchFilter">
            <label htmlFor="keywordSearchFilterTextField" className="sr-only">
                Søk etter nøkkelord
            </label>
            <TextField
                type="search"
                id="keywordSearchFilterTextField"
                name="keywords"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                helpText="F.eks treningsrom eller basseng"
                maxLength={100}
                enterKeyHint="search"
                className="w-full"
            />

            <Button data-testid="keywordFilterButton" type="submit">
                Søk
            </Button>
        </form>
    );
};
